<script>

import Multiselect from "@vueform/multiselect";
import api from "@/axios";
import Loader from "../components/loader";
import Layout from '../../layouts/main'
import PageHeader from '@/components/page-header'
import WmsOsTable from './wmsos-table'
import appConfig from "@/app.config";
import exportFromJSON from "export-from-json"
import Swal from "sweetalert2";
import {getBaseUrl} from "@/helpers/baseUrl";

export default {
  page: {
    title: "Ordem de Serviço Saída (WMS)",
    meta: [{ name: "description", content: appConfig.description }]
  },
  components: { Layout, PageHeader, WmsOsTable, Loader, Multiselect },
  mounted() {
    console.log('mounted wmsos-list_0')
    this.atualizaDataList()
  },
  data() {
    return {
      title: 'Ordem de Serviço Saída (WMS)',
      items: [
        {
          text: 'Estoque',
          href: '/',
        },
        {
          text: 'Ordem de Serviço Saída (WMS)',
          active: true,
        },
      ],
      loadingList: true,
      loadingGraph: true,
      wmsosList: null,
      empreData: null,
      pesqTextFilter: '',
      statusFilter: 'T',
      valorTotalConf: 0,
      valorTotalElab: 0,
      valorTotalFat: 0,
      showAssocRoma: false,
      idRomaneioAssoc: 0,
      dtListPesqRoma: null,


    }
  },
  methods: {

    pesqRomaneio(evt){
      console.log('pesqRomaneio')
      console.log(evt)
      let query = evt
      if (query.length > 1){
        api.get(`${getBaseUrl()}api/wmsromapesq`, {
          params: { q: query }
        }).then((res) => {
          console.log('then axios')
          console.log(res.data)
          this.dtListPesqRoma = res.data
        });
      }
    },



    // escolheuRoma(){
    //   console.log('escolheuRoma')
    //   api.get(`${getBaseUrl()}api/romaneio`, {
    //     params: { coddata: this.romaneioData.cliente }
    //   }).then((res) => {
    //     console.log('then axios')
    //     console.log(res.data)
    //     this.clienteData = res.data[0]
    //     this.ultPedsData = res.data[1]
    //
    //   })
    // },

    confirmarAssocRoma(){
      console.log('associarRomaneio')
      // console.log(this.wmsosList)
      let idsAssoc = []
      this.wmsosList.forEach((value) => {
        // console.log(value)
        if (value.checked === true){
          idsAssoc.push(value.id)
          // idsAssoc = idsAssoc + value.id.toString()
        }
      })
      console.log('idsAassociar')
      console.log(idsAssoc)

      api.post(`${getBaseUrl()}api/wmsromawmsos`, {
        idRoma: this.idRomaneioAssoc,
        idsData: idsAssoc
      }).then((res) => {
        console.log('then axios')
        console.log(res)
        // this.produtoData = res.data[0]
        // this.loadingList = false
        this.showAssocRoma = false


        Swal.fire({
          position: "top-end",
          icon: "success",
          title: "Informações salvas com sucesso!",
          showConfirmButton: false,
          timer: 1500
        })


        this.atualizaDataList()

      })

    },


    associarRomaneio() {

      let algumAssoc = false
      this.wmsosList.forEach((value) => {
        // console.log(value)
        if (value.checked === true){
          algumAssoc = true
          // idsAssoc = idsAssoc + value.id.toString()
        }
      })

      if (algumAssoc === false){
        Swal.fire({
          position: "top-end",
          icon: "warning",
          title: "Favor selecionar algum movimento antes de associar.",
          showConfirmButton: false,
          timer: 1500
        })
      } else {
        this.showAssocRoma = true
      }



    },


    emitRelat001(){
      console.log('emitRelat001')
      this.loadingList = true

      api.get(`${getBaseUrl()}api/relped01`, {
        responseType: 'blob'
      }).then((res) => {
        var fileURL = window.URL.createObjectURL(new Blob([res.data]));
        var fileLink = document.createElement('a');
        fileLink.href = fileURL;
        fileLink.setAttribute('download', 'Relatorio_wmsos_001.pdf');
        document.body.appendChild(fileLink);
        fileLink.click();
        this.loadingList = false
      })

    },

    emitRelat002(){
      console.log('emitRelat002')
      this.loadingList = true

      api.get(`${getBaseUrl()}api/relped02`, {
        responseType: 'blob'
      }).then((res) => {
        var fileURL = window.URL.createObjectURL(new Blob([res.data]));
        var fileLink = document.createElement('a');
        fileLink.href = fileURL;
        fileLink.setAttribute('download', 'Relatorio_wmsos_002.pdf');
        document.body.appendChild(fileLink);
        fileLink.click();
        this.loadingList = false
      })

    },

    emitRelat003(){
      console.log('emitRelat003')
      this.loadingList = true

      api.get(`${getBaseUrl()}api/relped03`, {
        responseType: 'blob'
      }).then((res) => {
        var fileURL = window.URL.createObjectURL(new Blob([res.data]));
        var fileLink = document.createElement('a');
        fileLink.href = fileURL;
        fileLink.setAttribute('download', 'Relatorio_wmsos_003.pdf');
        document.body.appendChild(fileLink);
        fileLink.click();
        this.loadingList = false
      })

    },


    exportExcel(){
      console.log('exportExcel')
      const data = this.wmsosList
      const fileName = "exp_dados";
      const exportType = exportFromJSON.types.xls;
      if (data) exportFromJSON({ data, fileName, exportType });
    },

    atualizaDataList(){
      this.loadingList = true
      api.get(`${getBaseUrl()}api/wmsossaidalist`, {
        params: {
          'q': this.pesqTextFilter,
          's': this.statusFilter
        }
      }).then((res) => {
        console.log('then axios wms-os')
        console.log(res.data)

        this.wmsosList = res.data[0]
        this.empreData = res.data[1]
        this.title = `(${this.wmsosList.length}) Ordem de Serviço Saída (WMS)`
        this.loadingList = false

        // console.log('res.data[1]')
        // console.log(res.data[1])
      })
    },

    criarNovo() {
      console.log('criarNovo')
      // this.updating = !this.updating
    },

    formatDecimal(value) {
      // console.log('format_value')
      // console.log(value)
      // console.log(typeof value)
      if(value){
        let value_n = parseFloat(value)
        return value_n.toLocaleString('pt-BR', {style: 'decimal', minimumFractionDigits: 2});
      }
      return "0,00";
    },

    formatInteger(value) {
      // console.log('format_value')
      // console.log(value)
      // console.log(typeof value)
      if(value){
        let value_n = parseFloat(value)
        return value_n.toLocaleString('pt-BR', {style: 'decimal', minimumFractionDigits: 0});
      }
      return 0.00;
    }


  },



}
</script>

<template>
  <Layout>

    <PageHeader :title="title" :items="items" />
    <div class="row">
      <div class="col-12">
        <div class="card">
          <div class="card-body">
            <div class="row mb-2">


              <div class="col-sm-2">
                <div class="search-box me-2 mb-2 d-inline-block">
                  <div class="position-relative">
                    <input
                        id="inputPesquisa"
                        type="text"
                        v-model="pesqTextFilter"
                        class="form-control"
                        placeholder="Enter para pesquisar..."
                        @change="atualizaDataList"/>
                    <i class="bx bx-search-alt search-icon"></i>
                  </div>
                </div>
              </div>

              <div class="col-sm-1">
                <div class="search-box me-2 mb-2 d-inline-block">
                  <div class="position-relative">
                    <select
                        id="selectStatus"
                        v-model="statusFilter"
                        @change="atualizaDataList"
                        class="form-control select2-search-disable">
                      <option value="T" selected>Todos</option>
                      <option value="SM">Sem Romaneio</option>
                      <option value="AB">Em Aberto</option>
                      <option value="SE">Conferido</option>
                      <option value="CA">Cancelados</option>
                    </select>
                    <i class="bx bx-filter-alt search-icon"></i>
                  </div>
                </div>
              </div>



              <div class="col-sm-2" >

                <b-dropdown
                    ngbDropdown
                    menu-class="dropdown-menu-md dropdown-menu-end"
                    right
                    variant="light">
                  <template v-slot:button-content>
                    <i class="mdi mdi-help me-1"></i>
                    <span class="d-none d-sm-inline-block" ngbDropdownToggle>
                      Auxiliar
                      <i class="mdi mdi-chevron-down"></i>
                    </span>
                  </template>


                  <div v-if="!loadingList">
                    <div class="dropdown-item-text">
                      <div>
                        <p class="text-muted mb-2">Total</p>
                        <h5 class="mb-0">{{ formatDecimal(0) }} (Valor Total) </h5>
                      </div>
                    </div>
                    <!--                    <b-dropdown-divider></b-dropdown-divider>-->
                    <!--                    <b-dropdown-item>-->
                    <!--                      Faturado:-->
                    <!--                      <span class="float-end"> {{ formatDecimal(valorTotalFat) }} (0%)</span>-->
                    <!--                    </b-dropdown-item>-->
                    <!--                    <b-dropdown-item>-->
                    <!--                      Confirmado:-->
                    <!--                      <span class="float-end"> {{ formatDecimal(valorTotalConf) }} (0%)</span>-->
                    <!--                    </b-dropdown-item>-->
                    <!--                    <b-dropdown-item>-->
                    <!--                      Com Elaboração:-->
                    <!--                      <span class="float-end"> {{ formatDecimal(valorTotalElab) }} (0%)</span>-->
                    <!--                    </b-dropdown-item>-->

                    <!--                    <b-dropdown-divider></b-dropdown-divider>-->
                    <!--                    <a class="dropdown-item text-primary text-center"-->
                    <!--                       @click="exportExcel"-->
                    <!--                       href="javascript: void(0);">-->
                    <!--                      Exportar Excel-->
                    <!--                    </a>-->

                    <!--                    <b-dropdown-divider></b-dropdown-divider>-->
                    <!--                    <a class="dropdown-item text-primary text-center"-->
                    <!--                       @click="emitRelat001"-->
                    <!--                       href="javascript: void(0);">-->
                    <!--                      Relatório de Ordem de Serviço Diário-->
                    <!--                    </a>-->

                    <!--                    <a class="dropdown-item text-primary text-center"-->
                    <!--                       @click="emitRelat002"-->
                    <!--                       href="javascript: void(0);">-->
                    <!--                      Relatório de Ordem de Serviço Mês-->
                    <!--                    </a>-->

                    <!--                    <a class="dropdown-item text-primary text-center"-->
                    <!--                       @click="emitRelat003"-->
                    <!--                       href="javascript: void(0);">-->
                    <!--                      Ordem de Serviço por Representante-->
                    <!--                    </a>-->

                  </div>

                </b-dropdown>
              </div>

              <div class="col-sm-2">

                <b-button variant="outline-info" class="mx-2" @click="associarRomaneio" >
                  <i class="bx bxs-layer font-size-16 align-middle me-2"></i>
                  Associar a Romaneio
                </b-button>

              </div>

              <div class="col-sm-5">
                <div class="text-sm-end">
                  <router-link :to="`/orcamento/editar/0`">
                    <button type="button" class="btn btn-success btn-rounded mb-2 me-2" >
                      <i class="mdi mdi-plus me-1"></i> Novo Orçamento
                    </button>
                  </router-link>
                </div>
              </div>
            </div>


            <Loader v-if="loadingList" style="min-height: 400px;">
            </Loader>

            <WmsOsTable v-if="!loadingList"  :wmsosList="wmsosList"  :empreData="empreData" />


            <ul class="pagination pagination-rounded justify-content-end mb-2">
              <li class="page-item disabled">
                <a class="page-link" href="javascript: void(0);" aria-label="Previous">
                  <i class="mdi mdi-chevron-left"></i>
                </a>
              </li>
              <li class="page-item active">
                <a class="page-link" href="javascript: void(0);">1</a>
              </li>
              <li class="page-item">
                <a class="page-link" href="javascript: void(0);">2</a>
              </li>
              <li class="page-item">
                <a class="page-link" href="javascript: void(0);">3</a>
              </li>
              <li class="page-item">
                <a class="page-link" href="javascript: void(0);">4</a>
              </li>
              <li class="page-item">
                <a class="page-link" href="javascript: void(0);">5</a>
              </li>
              <li class="page-item">
                <a class="page-link" href="javascript: void(0);" aria-label="Next">
                  <i class="mdi mdi-chevron-right"></i>
                </a>
              </li>
            </ul>
          </div>
          <!-- end card-body -->
        </div>
        <!-- end card -->
      </div>
      <!-- end col -->
    </div>

    <b-modal title="Associar a Romaneio" v-model="showAssocRoma" centered hide-footer>
      <div class="col-md-12">
<!--        <div class="mb-3">-->
<!--          <label for="wmsroma_id">Favor informar ID Romaneio</label>-->
<!--          <input-->
<!--              id="Id wmsroma_id"-->
<!--              v-model="idRomaneioAssoc"-->
<!--              type="number"-->
<!--              class="form-control"-->
<!--              placeholder="ID Romaneio"/>-->
<!--        </div>-->

        <div class="mb-3">
          <span>Selecionar Romaneio  {{ idRomaneioAssoc }}</span>

          <multiselect id="inputRomaneio"
                       @search-change="pesqRomaneio"
                       v-model="idRomaneioAssoc"


                       placeholder="Pesquisar romaneio"
                       :options="dtListPesqRoma"
                       :searchable="true"
                       label="nome"
                       track-by="nome"
                       value-prop="id">
            <template #option="slotProps">
              <div class="row">
                <div>
                  <span class="text-info">
                    {{ slotProps.option.id }}
                  </span>
                  <span class="mx-4" >
                    {{ slotProps.option.cnpj }}
                  </span>
                </div>
                <div class="mt-2 font-size-20">{{ slotProps.option.nome }}</div>
                <div class="align-items-end text-end align-content-end">{{ slotProps.option.motorista }}</div>
              </div>
            </template>
          </multiselect>

        </div>

        <div class="text-end mt-5">
          <b-button variant="light" @click="showAssocRoma = false">
            <i class="bx bx-block font-size-16 align-middle me-2"></i>
            Cancelar
          </b-button>
          <b-button :disabled="idRomaneioAssoc === 0"
              type="submit" variant="success" class="ms-1" @click="confirmarAssocRoma()">
            <i class="bx bx-check-double font-size-16 align-middle me-2"></i>
            Confirmar
          </b-button>
        </div>
      </div>

    </b-modal>

  </Layout>
</template>
